import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { setLSTBRData } from "../../redux/actions/leadSourceActions";

import {
    Card,
    CardContent,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    makeStyles,
    Button,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    Modal,
    Backdrop,
    Fade,
    TextField,
    IconButton
} from "@material-ui/core";

// Icons
import BarChartIcon from "@material-ui/icons/BarChart";
import RefreshIcon from "@material-ui/icons/Refresh";
import CloseIcon from "@material-ui/icons/Close";
import GetAppIcon from "@material-ui/icons/GetApp";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

const useStyles = makeStyles(() => ({
    root: {
        padding: 20,
        background: "#f5f7fa"
    },
    card: {
        borderRadius: 12,
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
    },
    headerCell: {
        background: "#1e3a8a",
        color: "#fff",
        fontWeight: 600,
        textAlign: "center",
        position: "sticky",
        top: 0,
        zIndex: 2
    },
    cell: {
        textAlign: "center",
        fontSize: 13,
        border: '1px solid #eee5e5',
    },
    row: {
        "&:nth-of-type(odd)": {
            backgroundColor: "#fafafa"
        },
        "&:hover": {
            backgroundColor: "#eef2ff"
        }
    },
    badge: {
        display: "inline-block",
        padding: "3px 8px",
        borderRadius: 8,
        fontSize: 11,
        marginTop: 4,
        background: "#e0f2fe",
        color: "#0369a1",
        fontWeight: 500
    }
}));

const SOURCE_TYPES = [
    "Facebook",
    "Google",
    "Partnership",
    "Reference",
    "Walk-In",
    "Channel Partner",
    "Others"
];

const LeadSourceBookingTable = ({ startDate, endDate, dateType, ...props }) => {
    const classes = useStyles();
    const lstbrData = useSelector((state) => state.leadSource.lstbrData);
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [lastUsedParams, setLastUsedParams] = useState(null);
    const [isInitialRender, setIsInitialRender] = useState(true);
    const SEVENTH_BUTTON_DISABLE_UNTIL_KEY = 'seventhButton_disableUntil';
    const [isDisabled, setIsDisabled] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);
    const [isSpinning, setIsSpinning] = useState(false);

    const [openModal, setOpenModal] = useState(false);
    const [selectedLeads, setSelectedLeads] = useState([]);
    const [selectedTitle, setSelectedTitle] = useState("");

    const [page, setPage] = useState(0);
    const rowsPerPage = 50;
    const [search, setSearch] = useState("");

    const isEqual = (obj1, obj2) => {
        // First check if both objects have the same keys
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        // Check if all keys in obj2 exist in obj1
        for (const key of keys2) {
            if (!keys1.includes(key)) {
                return false;
            }
        }

        // Then compare each key's value
        for (const key in obj1) {
            if (Array.isArray(obj1[key])) {
                // For arrays, check if they have the same length and same items
                if (!Array.isArray(obj2[key]) || obj1[key].length !== obj2[key].length) {
                    return false;
                }

                // For arrays of objects with _id, compare by _id
                if (obj1[key].length > 0 && obj1[key][0]?._id) {
                    const obj1Ids = new Set(obj1[key].map(item => item._id));
                    const obj2Ids = new Set(obj2[key].map(item => item._id));

                    // Check if sets are equal
                    if (obj1Ids.size !== obj2Ids.size) {
                        return false;
                    }

                    for (const id of obj1Ids) {
                        if (!obj2Ids.has(id)) {
                            return false;
                        }
                    }
                } else {
                    // Simple comparison for primitive arrays
                    for (let i = 0; i < obj1[key].length; i++) {
                        if (obj1[key][i] !== obj2[key][i]) {
                            return false;
                        }
                    }
                }
            } else if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;
    };

    const fetchData = async () => {
        let currentObj = {
            startDate,
            endDate,
            dateType
        };
        let shouldMakeApiCall = false;

        // Case 1: No lstbrData - must call API
        if (!lstbrData || lstbrData === null) {
            shouldMakeApiCall = true;
        }
        // Case 2: Not initial render AND parameters changed
        else if (!isInitialRender && lastUsedParams && !isEqual(lastUsedParams, currentObj)) {
            shouldMakeApiCall = true;
        }

        setLoading(true);
        try {
            if (shouldMakeApiCall) {
                // Call API with current parameters
                let response = await HttpService.getLeadSourceTypeBookings(currentObj);
                setData(response.data?.data);
                dispatch(setLSTBRData(response.data?.data));
            } else {
                // Use existing data
                setData(lstbrData || []);
            }

            // Always save the current parameters
            setLastUsedParams({ ...currentObj });

            // No longer initial render after first execution
            if (isInitialRender) {
                setIsInitialRender(false);
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        }
        // try {
        //     const res = await HttpService.getLeadSourceTypeBookings(currentObj);

        //     let apiData = res?.data?.data || [];

        //     // SORT (latest month first)
        //     apiData.sort((a, b) => {
        //         const d1 = new Date(a.year, a.month - 1);
        //         const d2 = new Date(b.year, b.month - 1);
        //         return d2 - d1;
        //     });

        //     setData(apiData);
        // } catch (err) {
        //     props.setSnackInfo(
        //         err?.response?.data?.message || "Failed to fetch data",
        //         "error"
        //     );
        // }
        setLoading(false);
    };

    useEffect(() => {
        // Check if there's a stored disable time in localStorage
        const disableUntilTimestamp = localStorage.getItem(SEVENTH_BUTTON_DISABLE_UNTIL_KEY);

        if (disableUntilTimestamp) {
            const now = new Date().getTime();
            const disableUntil = parseInt(disableUntilTimestamp, 10);

            // If the disable time is in the future, calculate remaining time
            if (disableUntil > now) {
                const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
                setTimeLeft(remainingTimeInSeconds);
                setIsDisabled(true);
            } else {
                // If the time has passed, clear localStorage
                localStorage.removeItem(SEVENTH_BUTTON_DISABLE_UNTIL_KEY);
                setIsDisabled(false);
                setTimeLeft(0);
            }
        }

        // Set up timer to update remaining time
        let timer;
        if (isDisabled && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft(prevTime => {
                    const newTime = prevTime - 1;
                    if (newTime <= 0) {
                        // When time is up, clear localStorage and enable button
                        localStorage.removeItem(SEVENTH_BUTTON_DISABLE_UNTIL_KEY);
                        setIsDisabled(false);
                        return 0;
                    }
                    return newTime;
                });
            }, 1000);
        }

        return () => clearInterval(timer);
    }, [isDisabled, timeLeft]);

    // Format time for display
    const formatTimeLeft = () => {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    // Replace your existing handleRefreshClick with this
    const handleRefreshClick = () => {
        // Calculate the timestamp 4 minutes from now
        const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);

        // Store the timestamp in localStorage
        localStorage.setItem(SEVENTH_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());

        // Disable the button for 4 minutes
        setIsDisabled(true);
        setTimeLeft(240); // 4 minutes in seconds

        // Run the original functionality
        setIsSpinning(true);
        getRefreshedData();
        setTimeout(() => {
            setIsSpinning(false);
        }, 1000);
    };

    /* ---------------- FETCH DATA ---------------- */

    const getRefreshedData = async () => {
        setLoading(true);
        try {
            let obj = {
                startDate,
                endDate,
                dateType
            };
            const res = await HttpService.getLeadSourceTypeBookings(obj);

            let apiData = res?.data?.data || [];

            setData(apiData);
            dispatch(setLSTBRData(apiData));
        } catch (err) {
            props.setSnackInfo(
                err?.response?.data?.message || "Failed to fetch data",
                "error"
            );
        }
        setLoading(false);
    };

    const handleCellClick = (leads, title) => {
        setSelectedLeads(leads || []);
        setSelectedTitle(title);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setPage(0);
        setSearch("")
    };

    useEffect(() => {
        fetchData();
    }, [startDate, endDate]);

    /* ---------------- MONTH FORMAT ---------------- */
    const getMonthName = (month, year) => {
        const date = new Date(year, month - 1);

        const monthShort = date.toLocaleString("default", { month: "short" });
        const yearShort = String(year).slice(-2); // last 2 digits

        return `${monthShort}-${yearShort}`;
    };

    const filteredLeads = selectedLeads.filter((lead) =>
        (lead.lead_no + "").includes(search) ||
        (lead.customerName || "").toLowerCase().includes(search.toLowerCase())
    );

    const paginatedLeads = filteredLeads.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    const exportCSV = () => {
        const headers = ["Lead No", "Customer", "Created At", "Lead Assigned Date", "Lead Won Date", "Experience Center", "Source Name", "Source Type", "Department", "Reason for Lost"];

        const formatDate = (date) => {
            return date ? new Date(date).toLocaleDateString() : "NA";
        };

        const rows = selectedLeads.map((l) => [
            l.lead_no || "NA",
            l.customerName || "NA",
            formatDate(l.createdAt),
            formatDate(l.leadAssignedDate),
            formatDate(l.leadWonDate),
            l.experienceCenterName || "NA",
            l.sourceName || "NA",
            l.sourceType || "NA",
            l.departmentName || "NA",
            l.reasonForLost || "Not Lost"
        ]);

        let csvContent =
            "data:text/csv;charset=utf-8," +
            [headers, ...rows].map((e) => e.join(",")).join("\n");

        const link = document.createElement("a");
        link.href = encodeURI(csvContent);
        link.download = `${selectedTitle}.csv`;
        link.click();
    };

    return (
        <div className={classes.root}>
            {/* HEADER CARD */}
            <Card className={classes.card} style={{ marginBottom: 20 }}>
                <CardContent>

                    {/* HEADER */}
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <Typography
                            variant="h2"
                            style={{
                                margin: 0,
                                fontWeight: 600,
                                fontSize: "18px",
                                display: "flex",
                                alignItems: "center",
                                gap: 10
                            }}
                        >
                            <BarChartIcon style={{ color: "#2563eb" }} />
                            Lead Source Type Booking Report
                        </Typography>

                        <Button
                            onClick={handleRefreshClick}
                            variant="contained"
                            startIcon={<RefreshIcon />}
                            disabled={isDisabled}
                            style={{
                                backgroundColor: isDisabled ? "#cccccc" : "#F47E46",
                                color: "#FFF2EB",
                                height: "36px",
                                textTransform: "none",
                                borderRadius: "6px"
                            }}
                        >
                            {isDisabled ? `Wait (${formatTimeLeft()})` : "Fetch New Data"}
                        </Button>
                    </div>

                    {/* INFO NOTE */}
                    <div
                        style={{
                            marginTop: 10,
                            padding: "6px 10px",
                            background: "#e0edff",
                            borderLeft: "4px solid #1d4ed8",
                            borderRadius: "6px",
                            fontSize: "12px",
                            color: "#1d4ed8",
                            display: "flex",
                            alignItems: "center",
                            gap: 6
                        }}
                    >
                        <InfoOutlinedIcon style={{ fontSize: 16, color: "#2563eb" }} />
                        Only date filters are applicable for this report
                    </div>

                </CardContent>
            </Card>

            {/* TABLE */}
            <Card className={classes.card}>
                <TableContainer style={{ maxHeight: "70vh" }}>
                    <Table stickyHeader>

                        {/* HEADER */}
                        <TableHead>
                            <TableRow>

                                <TableCell className={classes.headerCell}>
                                    Month And Year
                                </TableCell>

                                {SOURCE_TYPES.map((type) => (
                                    <TableCell key={type} className={classes.headerCell}>
                                        {type}
                                    </TableCell>
                                ))}

                                <TableCell className={classes.headerCell}>
                                    Total Monthly Bookings
                                </TableCell>

                            </TableRow>
                        </TableHead>

                        {/* BODY */}
                        <TableBody>
                            {loading ? (
                                <TableRow>
                                    <TableCell
                                        colSpan={SOURCE_TYPES.length + 2} // Month + sources + total
                                        align="center"
                                        style={{ height: "150px" }}
                                    >
                                        <CircularProgress size={30} />
                                    </TableCell>
                                </TableRow>
                            ) : (
                                data.map((row, i) => (
                                    <TableRow key={i} className={classes.row}>

                                        {/* Month */}
                                        <TableCell
                                            className={classes.cell}
                                            style={{
                                                background: "#1e3a8a",
                                                color: "#fff",
                                            }}
                                        >
                                            <strong>{getMonthName(row.month, row.year)}</strong>
                                        </TableCell>

                                        {/* Sources */}
                                        {SOURCE_TYPES.map((type) => {
                                            const source = row[type] || {
                                                bookings: 0,
                                                percentage: 0
                                            };

                                            return (
                                                <TableCell key={type} className={classes.cell}>
                                                    <div>
                                                        <strong
                                                            style={{ cursor: "pointer", color: "#1e3a8a", textDecoration: "underline" }}
                                                            onClick={() =>
                                                                handleCellClick(
                                                                    source.leads,
                                                                    `${type} - ${getMonthName(row.month, row.year)}`
                                                                )
                                                            }
                                                        >
                                                            {source.bookings}
                                                        </strong>
                                                    </div>
                                                    <div className={classes.badge}>
                                                        {source.percentage}%
                                                    </div>
                                                </TableCell>
                                            );
                                        })}

                                        {/* Total */}
                                        <TableCell className={classes.cell}>
                                            <strong
                                                style={{ cursor: "pointer", color: "#065f46", textDecoration: "underline" }}
                                                onClick={() =>
                                                    handleCellClick(
                                                        row.totalLeads,
                                                        `Total - ${getMonthName(row.month, row.year)}`
                                                    )
                                                }
                                            >
                                                {row.totalBookings}
                                            </strong>
                                        </TableCell>

                                    </TableRow>
                                ))
                            )}
                        </TableBody>

                    </Table>
                </TableContainer>
            </Card>

            <Modal
                open={openModal}
                onClose={handleCloseModal}
                closeAfterTransition
                BackdropComponent={Backdrop}
            >
                <Fade in={openModal}>
                    <div
                        style={{
                            width: "95%",
                            height: "90vh",
                            margin: "auto",
                            marginTop: "2%",
                            background: "#fff",
                            borderRadius: 12,
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >

                        {/* HEADER */}
                        <div
                            style={{
                                padding: "15px 20px",
                                background: "linear-gradient(90deg, #4f46e5, #9333ea)",
                                color: "#fff",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >
                            <div>
                                <Typography style={{ fontWeight: 600 }}>
                                    {selectedTitle} ({filteredLeads.length} leads)
                                </Typography>
                                <Typography style={{ fontSize: 12 }}>
                                    {filteredLeads.length} leads found
                                </Typography>
                            </div>

                            <div style={{ display: "flex", gap: 10 }}>
                                <Button
                                    startIcon={<GetAppIcon />}
                                    onClick={exportCSV}
                                    style={{ color: "#fff", border: "1px solid #fff" }}
                                >
                                    Export
                                </Button>

                                <IconButton onClick={handleCloseModal} style={{ color: "#fff" }}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        </div>

                        {/* SEARCH */}
                        <div style={{ padding: 15 }}>
                            <TextField
                                placeholder="Search leads..."
                                variant="outlined"
                                size="small"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setPage(0);
                                }}
                                style={{ width: 300 }}
                            />
                        </div>

                        {/* TABLE */}
                        <div style={{ flex: 1, overflow: "auto" }}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.headerCell}>#</TableCell>
                                        <TableCell className={classes.headerCell}>Lead No</TableCell>
                                        <TableCell className={classes.headerCell}>Customer Name</TableCell>
                                        <TableCell className={classes.headerCell}>Created At</TableCell>
                                        <TableCell className={classes.headerCell}>Lead Assigned Date</TableCell>
                                        <TableCell className={classes.headerCell}>Lead Won Date</TableCell>
                                        <TableCell className={classes.headerCell}>Experience Center Name</TableCell>
                                        <TableCell className={classes.headerCell}>Source Name</TableCell>
                                        <TableCell className={classes.headerCell}>Source Type</TableCell>
                                        <TableCell className={classes.headerCell}>Department</TableCell>
                                        <TableCell className={classes.headerCell}>Current Stage</TableCell>
                                        <TableCell className={classes.headerCell}>Reason for Lost</TableCell>

                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {paginatedLeads.map((lead, index) => (
                                        <TableRow key={index} className={classes.row}>
                                            <TableCell className={classes.cell}>
                                                {page * rowsPerPage + index + 1}
                                            </TableCell>

                                            <TableCell className={classes.cell}>
                                                <Link
                                                    to={`/project-logs/${lead?._id}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        color: "#1e3a8a",
                                                        textDecoration: "underline",
                                                        fontWeight: 500
                                                    }}
                                                >
                                                    {lead?.lead_no}
                                                </Link>
                                            </TableCell>

                                            <TableCell className={classes.cell}>
                                                {lead.customerName || "NA"}
                                            </TableCell>

                                            <TableCell className={classes.cell}>
                                                {lead.createdAt ? new Date(lead.createdAt).toLocaleDateString() : "NA"}
                                            </TableCell>

                                            <TableCell className={classes.cell}>
                                                {lead.leadAssignedDate ? new Date(lead.leadAssignedDate).toLocaleDateString() : "NA"}
                                            </TableCell>

                                            <TableCell className={classes.cell}>
                                                {lead.leadWonDate ? new Date(lead.leadWonDate).toLocaleDateString() : "NA"}
                                            </TableCell>

                                            <TableCell className={classes.cell}>
                                                {lead.experienceCenterName || "NA"}
                                            </TableCell>

                                            <TableCell className={classes.cell}>
                                                {lead.sourceName || "NA"}
                                            </TableCell>

                                            <TableCell className={classes.cell}>
                                                {lead.sourceType || "NA"}
                                            </TableCell>

                                            <TableCell className={classes.cell}>
                                                {lead.departmentName}
                                            </TableCell>

                                            <TableCell className={classes.cell}>
                                                {lead.currentStage}
                                            </TableCell>

                                            <TableCell className={classes.cell}>
                                                {lead.reasonForLost ? lead.reasonForLost : "Not Lost"}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>

                        {/* FOOTER PAGINATION */}
                        <div
                            style={{
                                padding: 10,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >
                            <Typography style={{ fontSize: 12 }}>
                                Showing {page * rowsPerPage + 1} -{" "}
                                {Math.min((page + 1) * rowsPerPage, filteredLeads.length)} of{" "}
                                {filteredLeads.length}
                            </Typography>

                            <div>
                                <IconButton
                                    disabled={page === 0}
                                    onClick={() => setPage((p) => p - 1)}
                                >
                                    <ArrowBackIosIcon fontSize="small" />
                                </IconButton>

                                <span style={{ margin: "0 10px" }}>
                                    Page {page + 1} of {Math.ceil(filteredLeads.length / rowsPerPage)}
                                </span>

                                <IconButton
                                    disabled={(page + 1) * rowsPerPage >= filteredLeads.length}
                                    onClick={() => setPage((p) => p + 1)}
                                >
                                    <ArrowForwardIosIcon fontSize="small" />
                                </IconButton>
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
        </div>
    );
};

export default connect(
    null,
    { setLoading, setSnackInfo }
)(LeadSourceBookingTable);